import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "option"]

  connect() {
    this.syncSelection()
  }

  select(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.emojiValue
    if (!value || !this.hasInputTarget) return

    this.inputTarget.value = value
    this.updateSelection(value)
  }

  syncSelection() {
    if (!this.hasInputTarget || !this.hasOptionTarget) return

    const initialValue = this.inputTarget.value || this.optionTargets[0]?.dataset.emojiValue
    if (!initialValue) return

    this.inputTarget.value = initialValue
    this.updateSelection(initialValue)
  }

  updateSelection(value) {
    this.optionTargets.forEach((option) => {
      const selected = option.dataset.emojiValue === value
      option.classList.toggle("selected", selected)
      option.setAttribute("aria-pressed", selected ? "true" : "false")
    })
  }
}
